module.exports = __webpack_public_path__ + "images/the-magician-b136d94aa3fab8d13693eb205368dfac.png";